import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { SubHeaderData } from 'src/app/models/sub-header-data';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { InstanceSettingModel } from '../../models/informate/instance-setting-model';
import { MatTabGroup } from '@angular/material/tabs';
import { TranslocoService } from '@jsverse/transloco';

// TODO: START ###### >>> DUMMY CODE FROM IDMSUI <<< ######
export interface PeriodicElement2 {
    number_one: string;
    number_two: string;
    number_three: string;
    number_four: string;
    number_five: string;
    number_six: string;
    number_seven: string;
    number_eight: string;
    number_nine: string;
    number_ten: string;
    number_eleven: string;
    number_twelve: string;
    number_thirteen: string;
    number_fourteen: string;
    number_fifteen: string;
    number_sixteen: string;
}

@Component({
    selector: 'app-settings-idms',
    templateUrl: './settings-idms.component.html',
    styleUrls: ['./settings-idms.component.scss'],
    standalone: false
})
export class SettingsIdmsComponent implements OnInit, OnDestroy {
    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

    generalTabIndex: any;
    subHeaderData: SubHeaderData;
    idmsFormGroup: UntypedFormGroup;
    // ruleConfigureFormGroup: UntypedFormGroup;
    destroy$: Subject<any>;
    isDbLookUpTab: boolean;
    isMaterialAliasTab: boolean;
    viewPipeCodesTab: boolean;
    DataUploadsTab: boolean;
    viewApprovalsTab: boolean;
    viewRulesTab: boolean;
    viewBarCodeTab: boolean;
    viewCalcPefTab: boolean;
    viewdataUploadTab: boolean;
    profileSettingAreaId: string;
    userSettings: InstanceSettingModel[];
    defaultUnitSettings: InstanceSettingModel[];
    calculationPreferenceSettings: InstanceSettingModel[];
    public idmsPassPercentageForm: UntypedFormGroup;
    ruleValues: any[] = [];
    constructor(
        private formBuilder: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private userUtilityService: UserUtilityService,
        private fb: UntypedFormBuilder,
        private cd: ChangeDetectorRef,
        private user_utility: UserUtilityService,
        private customToastService: CustomToastService,
        private router: Router,
        private route: ActivatedRoute,
        private globalEmittersService: GlobalEmittersService,
        private translocoService: TranslocoService
    ) {
        this.destroy$ = new Subject();
        this.isDbLookUpTab = false;
        this.isMaterialAliasTab = false;
    }

    // constructor(private modalService: NgbModal,private user_utility: UserUtilityService) { }

    async ngOnInit(): Promise<void> {
        this.globalEmittersService.RuleSaveDisable = false;
        this.subHeaderData = this.setSubHeaderValues();
        this.viewPipeCodesTab = await this.userUtilityService.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.View);
        this.viewApprovalsTab = await this.userUtilityService.checkUserPermissionDataAndRoute('settings-iDMS-approvals', userActions.View);
        this.viewRulesTab = await this.userUtilityService.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.View);
        this.viewBarCodeTab = await this.userUtilityService.checkUserPermissionDataAndRoute('settings-iDMS-barcode', userActions.View);
        this.viewCalcPefTab = await this.userUtilityService.checkUserPermissionDataAndRoute('settings-calculation-preferences', userActions.View); //For now we are using informate permission we need to change it as idms settings
        this.viewdataUploadTab = await this.userUtilityService.checkUserPermissionDataAndRoute('settings-iDMS-dataUploads', userActions.View); //For now we are using informate permission we need to change it as idms settings
        this.globalEmittersService.passPercentageSaveEvent.subscribe((res) => {
            if (res) {
                this.saveSettingsOutputHandler(res);
            }
        });
        // this.globalEmittersService.passPercentageSaveEvent.subscribe((res) => {
        //     if (res) {
        //         this.saveSettingsOutputHandler(res);
        //     }
        // });
        this.initializeFormGroup();
        await this.checkUserAccessLevel();
        this.getSettings();
        // this.ruleConfigureFormGroup = null;
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText = this.translocoService.translate('SETTING_PAGE.SETTING_SUB_HEADER.Settings');
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../../assets/media/logos/settings-black.png';
        headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/settings-yellow.png';
        headerData.isIdmsSettings = true;
        headerData.isGeneralSettings = false;
        headerData.isInstanceSettings = false;
        return headerData;
    }

    // * check user access levels
    async checkUserAccessLevel(): Promise<void> {
        this.isDbLookUpTab = !(await this.userUtilityService.checkUserPermissionDataAndRoute('viewDbLookUpField', userActions.View));
        this.isMaterialAliasTab = await this.userUtilityService.checkUserPermissionDataAndRoute('viewMaterialAlias', userActions.View);
    }

    // * initialization of parent formGroup
    initializeFormGroup(): void {
        this.idmsFormGroup = this.formBuilder.group({
            dbLookUpMaterialAlias: new UntypedFormArray([]),
            materialAlias: new UntypedFormArray([]),
            pipeCodes: new UntypedFormArray([]),
            rulesFormGroup: new UntypedFormArray([]),
        });
    }

    ruleConfigureFormEmmiterHandler(event) {
        const rulesArray = this.idmsFormGroup.get('rulesFormGroup') as UntypedFormArray;
        let ruleConfigureFormGroup = event;
        if (ruleConfigureFormGroup?.valid) {
            if (
                this.ruleValues?.length > 0 &&
                this.ruleValues?.find((x) => !x.ApprovalRuleId || x.ApprovalRuleId == '0') &&
                ruleConfigureFormGroup.get('ApprovalRuleId')?.value
            ) {
                //If we create new rule then save allowed only if selected new rule if existing rule selected while creating new rule then save button will be disabled
                // this.ruleValues = [];
                // this.idmsFormGroup.get('rulesFormGroup').markAsPristine();
                // this.idmsFormGroup.markAsPristine();

                const ruleId = ruleConfigureFormGroup.get('ApprovalRuleId')?.value;
                const ruleName = ruleConfigureFormGroup.get('name')?.value;
                const existing = this.ruleValues.findIndex((ctrl) => ctrl.ApprovalRuleId === ruleId);
                if (existing !== -1) {
                    this.ruleValues[existing] = ruleConfigureFormGroup.value;
                } else {
                    if (ruleName) {
                        this.ruleValues.push(ruleConfigureFormGroup.value);
                    }
                }
            } else {
                // Extract a unique key to identify the form (e.g., ApprovalRuleId or name)
                const ruleId = ruleConfigureFormGroup.get('ApprovalRuleId')?.value;
                const ruleName = ruleConfigureFormGroup.get('name')?.value;

                // Try to find an existing form with same ruleId
                // const existingIndex = rulesArray.controls.findIndex((ctrl) => ctrl.get('ApprovalRuleId')?.value === ruleId);
                if (this.ruleValues?.length == 0) {
                    if (ruleName) {
                        this.ruleValues.push(ruleConfigureFormGroup.value);
                        if (this.globalEmittersService.RuleSaveDisable) {
                            this.idmsFormGroup.get('rulesFormGroup').markAsPristine();
                            this.idmsFormGroup.markAsPristine();
                        } else if (!ruleId || (ruleId && ruleId == '0')) {
                            this.idmsFormGroup.get('rulesFormGroup').markAsDirty();
                            this.idmsFormGroup.markAsDirty();
                        } else if (ruleConfigureFormGroup.valid) {
                            this.idmsFormGroup.get('rulesFormGroup').markAsDirty();
                            this.idmsFormGroup.markAsDirty();
                        }
                    }
                } else {
                    const existing = this.ruleValues.findIndex((ctrl) => ctrl.ApprovalRuleId === ruleId);
                    if (existing !== -1) {
                        const newValues = ruleConfigureFormGroup.value;
                        const oldValues = this.ruleValues[existing];

                        // Compare old vs new — mark as dirty only if there’s any difference
                        const isChanged = JSON.stringify(oldValues) !== JSON.stringify(newValues);

                        if (this.globalEmittersService.RuleSaveDisable) {
                            this.idmsFormGroup.get('rulesFormGroup').markAsPristine();
                            this.idmsFormGroup.markAsPristine();
                        } else {
                            if ((isChanged && ruleId && ruleId != '0') || !ruleId || ruleId == '0') {
                                this.idmsFormGroup.get('rulesFormGroup').markAsDirty();
                                this.idmsFormGroup.markAsDirty();
                            }
                        }
                        this.ruleValues[existing] = ruleConfigureFormGroup.value;
                    } else {
                        if (ruleName) {
                            this.ruleValues.push(ruleConfigureFormGroup.value);
                            if (this.globalEmittersService.RuleSaveDisable) {
                                this.idmsFormGroup.get('rulesFormGroup').markAsPristine();
                                this.idmsFormGroup.markAsPristine();
                            } else if (!ruleConfigureFormGroup.value?.ApprovalRuleId) {
                                this.idmsFormGroup.get('rulesFormGroup').markAsDirty();
                                this.idmsFormGroup.markAsDirty();
                            }
                        }
                    }
                }
            }
        } else {
            if (this.ruleValues?.length > 0) {
                const ruleId = ruleConfigureFormGroup.get('ApprovalRuleId')?.value;
                const existing = this.ruleValues.findIndex((ctrl) => ctrl.ApprovalRuleId === ruleId);
                if (existing !== -1) {
                    this.ruleValues[existing] = ruleConfigureFormGroup.value;
                }
            }
            this.idmsFormGroup.get('rulesFormGroup').markAsPristine();
            this.idmsFormGroup.markAsPristine();
        }
    }

    getSettings(): void {
        this.mgmtApi.getSettingProfileAreaId('informate').subscribe((res) => {
            if (res.success === true) {
                this.profileSettingAreaId = res.response.settingAreaId;
                if (this.profileSettingAreaId) {
                    this.mgmtApi.getSettingbySettinfAreaIdForIdms(this.profileSettingAreaId).subscribe((userSettings) => {
                        if (userSettings.success === true) {
                            this.userSettings = userSettings.response;
                            this.buildForm();
                            this.defaultUnitSettings = this.getSectionData('Defaults', false);
                            this.calculationPreferenceSettings = this.getSectionData('Calculation Preferences', false);
                            this.cd.markForCheck();
                        } else {
                            this.user_utility.errorModelPopup(userSettings.message);
                        }
                    });
                }
            } else {
                this.user_utility.errorModelPopup(res.message);
            }
        });
    }

    buildForm(): void {
        this.idmsPassPercentageForm = null;
        this.idmsPassPercentageForm = this.fb.group({});

        this.userSettings.forEach((obj, index) => {
            const validatorsToAdd = [];

            if (obj.setting.isRequired) {
                validatorsToAdd.push(Validators.required);
            }

            this.idmsPassPercentageForm.addControl(obj.setting.key, this.fb.control(this.getFormStateValue(obj), validatorsToAdd));
        });
    }

    getSectionData(sectionName: string, isSubSection: boolean = false): InstanceSettingModel[] {
        const sections: InstanceSettingModel[] = this.userSettings.filter((item: InstanceSettingModel) => {
            if (isSubSection) {
                return item.setting.settingSubSection?.name.toLowerCase() === sectionName.toLowerCase();
            }

            return item.setting.settingSubSection?.settingSection.name.toLowerCase() === sectionName.toLowerCase();
        });

        return sections;
    }

    getFormStateValue(instanceSetting: InstanceSettingModel) {
        if (instanceSetting.value) {
            return instanceSetting.value;
        }

        if (instanceSetting.settingValue) {
            return instanceSetting.settingValue.settingValueId;
        }

        return null;
    }

    async saveSettingsOutputHandler(saveSettings: boolean) {
        if (this.user_utility.noneSelectedPassPct) {
            this.customToastService.infoToast('Atleast one pass must be selected!', 'Info');
            this.idmsPassPercentageForm.markAsDirty();
            this.idmsPassPercentageForm.markAsTouched();
            this.idmsPassPercentageForm.updateValueAndValidity();

            return;
        }
        if (saveSettings) {
            // informate form...
            if (this.idmsPassPercentageForm) {
                const updateJson = [];

                Object.keys(this.idmsPassPercentageForm.controls).forEach((key) => {
                    const ctrl: AbstractControl = this.idmsPassPercentageForm.controls[key];
                    const json = {};

                    if (ctrl.dirty && ctrl.valid) {
                        const userSetting: InstanceSettingModel = this.userSettings.find((item) => item.setting.key === key);

                        if (userSetting) {
                            json['instanceSettingId'] = userSetting.instanceSettingId;
                            json['instanceId'] = userSetting.instanceId;
                            json['settingId'] = userSetting.setting.settingId;
                            if (userSetting.settingValue) {
                                json['settingValueId'] = ctrl.value; //userSetting.settingValue.settingValueId
                            } else if (userSetting.value) {
                                json['value'] = ctrl.value; //userSetting.value
                            }

                            updateJson.push(json);
                        }
                    }
                });

                // update mgmt service!
                if (updateJson.length !== 0) {
                    console.log(updateJson);
                    await this.updateSettingsInformate(updateJson);
                }
            }
        }
    }

    async updateSettingsInformate(updateJson) {
        await this.mgmtApi.updatePassPercentageSettings(updateJson).subscribe(async (result) => {
            if (result.success === true) {
                this.customToastService.successToast('Pass percentage settings saved successfully.', 'Success');
                this.globalEmittersService.passPercentageSaveEvent.next(false);
                this.mgmtApi.refreshUserDefaults();
                await this.getSettings();
            } else {
                // activeToast =
                this.customToastService.errorToast('Unable to save pass percentage settings. Please try again or contact customer care.', 'Error');
                this.router.navigate(['./'], { relativeTo: this.route });
            }
        });
    }

    tabChanged(event: any): void {
        this.generalTabIndex = this.tabGroup._tabs.find((tab) => tab.textLabel === event.tab.textLabel).ariaLabel;
    }

    clearRuleValuesDataHandler(event: any) {
        this.ruleValues = [];
        this.idmsFormGroup.get('rulesFormGroup').markAsPristine();
        this.idmsFormGroup.markAsPristine();
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
